// §0.5.6 Query hook for provider and system flags on an assessment.
// Reads from top-level 'provider-flags' collection, filtered by assessmentId + practiceId.

import { usePracticeAccess } from '@hb/react'
import { PROVIDER_FLAGS, ProviderFlag, User } from '@hb/shared'
import {
  collection,
  CollectionReference,
  DocumentReference,
  query,
  where,
} from 'firebase/firestore'
import { useMemo } from 'react'
import { useQuery } from '../useQuery'

export const useAssessmentProviderFlags = (
  patientRef: DocumentReference<User> | null,
  assessmentId: string | null | undefined,
) => {
  const { selectedPracticeId } = usePracticeAccess()
  const ref = useMemo(() => {
    if (!assessmentId || !selectedPracticeId || !patientRef) return null
    const col = collection(patientRef, PROVIDER_FLAGS) as CollectionReference<ProviderFlag>
    return query(
      col,
      where('assessmentId', '==', assessmentId),
      where('practiceId', '==', selectedPracticeId),
    )
  }, [assessmentId, selectedPracticeId, patientRef])
  return useQuery<ProviderFlag>(ref)
}
